/**
 * Ціна в USDT поруч зі звичайною ціною.
 *
 * Курс беремо з відкритого API НБУ прямо з браузера — він віддає
 * access-control-allow-origin: *, тому ні проксі, ні бекенду не потрібно.
 *
 * ВАЖЛИВО: НБУ не котирує USDT. Беремо курс ДОЛАРА і покладаємось на те,
 * що USDT ≈ USD. Саме тому в пілюлі стоїть ≈ — наближення подвійне.
 */
(function () {
  'use strict';

  var API = 'https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?valcode=USD&json';
  var CACHE_KEY = 'pv_nbu_usd';
  // НБУ оновлює курс раз на робочий день (близько 15:30 за Києвом). Дізнатись,
  // що дата змінилась, не зробивши запит, неможливо — тому кешуємо за TTL.
  // 6 годин: максимум 4 запити на користувача на добу, курс не застаріває.
  var TTL = 6 * 60 * 60 * 1000;

  var ratePromise = null;

  function readCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c || typeof c.rate !== 'number' || !c.fetchedAt) return null;
      return c;
    } catch (e) {
      return null;
    }
  }

  function writeCache(rate, date) {
    try {
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ rate: rate, date: date, fetchedAt: Date.now() })
      );
    } catch (e) {
      /* приватний режим / переповнене сховище — не критично, просто без кешу */
    }
  }

  function fetchRate() {
    var cached = readCache();

    if (cached && Date.now() - cached.fetchedAt < TTL) {
      return Promise.resolve(cached.rate);
    }

    return fetch(API)
      .then(function (res) {
        if (!res.ok) throw new Error('NBU HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var row = data && data[0];
        var rate = row && Number(row.rate);
        if (!rate || !isFinite(rate) || rate <= 0) throw new Error('NBU: некоректний курс');
        writeCache(rate, row.exchangedate);
        return rate;
      })
      .catch(function (err) {
        // Мережа впала, але старий курс є — беремо його. Він максимум на добу
        // застарілий, а в пілюлі й так стоїть ≈. Це чесніше, ніж ховати ціну.
        if (cached) return cached.rate;
        throw err;
      });
  }

  function getRate() {
    if (!ratePromise) ratePromise = fetchRate();
    return ratePromise;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  if (!customElements.get('usdt-price')) {
    customElements.define(
      'usdt-price',
      class extends HTMLElement {
        constructor() {
          super();
          this.numEl = this.querySelector('[data-usdt-num]');
          this.rate = null;
        }

        connectedCallback() {
          var self = this;

          getRate()
            .then(function (rate) {
              self.rate = rate;
              self.render(Number(self.dataset.price), false);
              self.hidden = false;
            })
            .catch(function () {
              // Курсу немає — пілюлі немає. Вигаданих цифр не показуємо.
              self.hidden = true;
            });

          // Подія теми несе {detail: {variant}}. Слухаємо в межах свого товару,
          // інакше на сторінках із кількома формами (quickview) пілюлі
          // перерахують одна одну.
          this.scope = this.closest('[data-product]') || document;
          this.onVariant = function (event) {
            var variant = event.detail && event.detail.variant;
            if (!variant || !variant.price) {
              self.hidden = true;
              return;
            }
            self.dataset.price = variant.price;
            if (self.rate) {
              self.render(variant.price, true);
              self.hidden = false;
            }
          };
          this.scope.addEventListener('theme:variant:change', this.onVariant);
        }

        disconnectedCallback() {
          if (this.scope && this.onVariant) {
            this.scope.removeEventListener('theme:variant:change', this.onVariant);
          }
        }

        /** priceCents — ціна у копійках, як віддає Shopify */
        value(priceCents) {
          var uah = Number(priceCents) / 100;
          return Math.round(uah / this.rate);
        }

        render(priceCents, animate) {
          if (!this.numEl || !this.rate || !priceCents) return;

          var text = this.value(priceCents).toLocaleString('uk-UA');
          var self = this;

          if (!animate || prefersReducedMotion()) {
            this.numEl.textContent = text;
            return;
          }

          // Перекидання числа: старе йде вгору, нове зʼявляється знизу
          this.numEl.classList.add('is-swap');
          setTimeout(function () {
            self.numEl.textContent = text;
            self.numEl.classList.remove('is-swap');
          }, 280);
        }
      }
    );
  }
})();
